import React from "react";

const PrivacyPolicy = () => {
  return (
    <div class="privacy-policy-sec ">
      <div class="container" style={{ width: "800px", paddingTop: "40px" }}>
        <h3>
          <strong>PRIVACY NOTICE</strong>
        </h3>
        <p>
          <strong>Last updated November 20, 2022</strong>
        </p>

        <p>
          Thank you for choosing to be part of our community at Music Therapy 3. We are committed to protecting your
          personal information and your right to privacy. If you have any questions or concerns about this privacy
          notice, or our practices with regards to your personal information, please contact us at
          <a
            href="mailto:gwshngt1@memphis.edu"
            class="__cf_email__"
            data-cfemail="37455e5b524e7744545a445a525a475f5e441954585a"
          >
            gwshngt1@memphis.edu
          </a>
          .
        </p>
        <p>
          When you visit our website <a href="https://admin.mt3health.com/">https://admin.mt3health.com/</a> (the
          "Website"), use our mobile application, as the case may be (the "App") and more generally, use any of our
          services (the "Services", which include the Website and App), we appreciate that you are trusting us with your
          personal information. We take your privacy very seriously. In this privacy notice, we seek to explain to you
          in the clearest way possible what information we collect, how we use it and what rights you have in relation
          to it. We hope you take some time to read through it carefully, as it is important. If there are any terms in
          this privacy notice that you do not agree with, please discontinue use of our Services immediately.
        </p>
        <p>
          This privacy notice applies to all information collected through our Services (which, as described above,
          includes our Website and App), as well as, any related services, or events.
        </p>
        <p>
          <strong>
            Please read this privacy notice carefully as it will help you understand what we do with the information
            that we collect.
          </strong>
        </p>

        <ul class="list-unstyled">
          <li>
            <a href="#first">1. WHAT INFORMATION DO WE COLLECT?</a>
          </li>
          <li>
            <a href="#second">2.HOW WE USE INFORMATION</a>
          </li>
          <li>
            <a href="#third">3.HOW LONG DO WE KEEP YOUR INFORMATION?</a>
          </li>
          <li>
            <a href="#fourth">4.DO WE MAKE UPDATES TO THIS NOTICE? </a>
          </li>
          <li>
            <a href="#fifth">5.HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</a>
          </li>
          <li>
            <a href="#sixth">6.THIRD-PARTY WEBSITES</a>
          </li>
          <li>
            <a href="#seventh">7.HOW WE COMMITTED TO PROVIDE SECURITY</a>
          </li>
          <li>
            <a href="#eighth">8.HOW CAN YOU CONTACT US ABOUT THIS NOTICE? </a>
          </li>
        </ul>
        <div id="first">
          <h4>
            <strong>1. WHAT INFORMATION DO WE COLLECT?</strong>
          </h4>
          <p>Personal information you disclose to us</p>
          <p>
            <em>In Short: We collect personal information that you provide to us.</em>
          </p>
          <p>
            We collect personal information that you voluntarily provide to us when you register on the Services,
            express an interest in obtaining information about us or our products and Services, when you participate in
            activities on the Services (such as by posting messages in our online forums or entering competitions,
            contests or giveaways) or otherwise when you contact us.
          </p>

          <p>
            The personal information that we collect depends on the context of your interactions with us and the
            Services, the choices you make and the products and features you use. The personal information we collect
            may include the following:
          </p>
          <p>
            All personal information that you provide to us must be true, complete and accurate, and you must notify us
            of any changes to such personal information.We may collect information about you in a variety of ways. The
            information we may collect via the Application depends on the content and materials you use, and includes:
          </p>
          <ul class="list">
            <li>
              <strong>Personal Data</strong>
              <br />
              Demographic and other personally identifiable information (such as your name and email address) that you
              voluntarily give to us when choosing to participate in various activities related to the Application,
              liking posts, sending feedback, and responding to surveys. If you choose to share data about yourself via
              your profile or other interactive areas of the Application, please be advised that all data you disclose
              in these areas is public and your data will be accessible to anyone who accesses the Application.
            </li>
            <li>
              <strong>Derivative Data</strong>
              <br />
              Information our servers automatically collect when you access the Application, such as your native actions
              that are integral to the Application, including liking, re-blogging, or replying to a post, as well as
              other interactions with the Application and other users via server log files.
            </li>
            <li>
              <strong>Mobile Device Access</strong>
              <br />
              We may request access or permission to certain features from your mobile device, including your mobile
              device’s storage. If you wish to change our access or permissions, you may do so in your device’s
              settings.
            </li>
            <li>
              <strong>Push Notifications</strong>
              <br />
              We may request to send you push notifications regarding your account or the Application. If you wish to
              opt-out from receiving these types of communications, you may turn them off in your device’s settings.
            </li>
            <li>
              <strong>Background Check Information</strong>
              <br />
              This includes information submitted during the CareGiver application process, such as SSN, Driving
              license. This information may be collected by an authorised vendor on Uber’s behalf.
            </li>
            <li>
              <strong>Location Data</strong>
              <br />
              We collect precise or approximate location data from caregivers and careseekers mobile devices when the
              service is running.
            </li>
            <li>
              <strong>Transaction Information</strong>
              <br />
              We collect transaction information related to the use of our services, service details (such as date and
              time, addresses) and payment transaction information (amount charged and payment method).
            </li>
          </ul>
        </div>
        <div id="second">
          <h4>
            <strong>2.HOW WE USE INFORMATION?</strong>
          </h4>
          <p>
            Provide you with amazing set products and services that we relentlessly improve. Here are the way we do
            that:
          </p>
          <ul class="list">
            <li>
              develop, operate, improve, deliver, maintain, and protect our products and services. May also use personal
              information for internal purposes such as auditing, data analysis and improve services.
            </li>
            <li>
              send you communications, including by email. For example we may use email to respond to support inquiries
              or to share information about our products and services that we think may interest you.
            </li>
            <li>
              Monitor and analyze trends and usage. and invite you to participate in surveys and promotions, as
              determined by your choices and communications preferences.
            </li>
          </ul>
          <p>
            if your account closed we may keep your personal data and other information required by law according to our
            data retention policy.
          </p>
        </div>
        <div id="third">
          <h4>
            <strong>3.HOW LONG DO WE KEEP YOUR INFORMATION?</strong>
          </h4>
          <p>
            <em>
              In Short: We keep your information for as long as necessary to fulfill the purposes outlined in this
              privacy notice unless otherwise required by law.
            </em>
          </p>
          <p>
            We will only keep your personal information for as long as it is necessary for the purposes set out in this
            privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting or
            other legal requirements). No purpose in this notice will require us keeping your personal information for
            longer than .
          </p>
          <p>
            When we have no ongoing legitimate business need to process your personal information, we will either delete
            or anonymize such information, or, if this is not possible (for example, because your personal information
            has been stored in backup archives), then we will securely store your personal information and isolate it
            from any further processing until deletion is possible.
          </p>
        </div>
        <div id="fourth">
          <h4>
            <strong>4.DO WE MAKE UPDATES TO THIS NOTICE?</strong>
          </h4>
          <p>
            <em>In Short: Yes, we will update this notice as necessary to stay compliant with relevant laws.</em>
          </p>
          <p>
            We may update this privacy notice from time to time. The updated version will be indicated by an updated
            "Revised" date and the updated version will be effective as soon as it is accessible. If we make material
            changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or
            by directly sending you a notification. We encourage you to review this privacy notice frequently to be
            informed of how we are protecting your information.
          </p>
        </div>
        <div id="fifth">
          <h4>
            <strong>5.HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU? </strong>
          </h4>
          <p>
            Based on the applicable laws of your country, you may have the right to request access to the personal
            information we collect from you, change that information, or delete it in some circumstances. To request to
            review, update, or delete your personal information, please submit a request form by clicking here.
          </p>
        </div>
        <div id="sixth">
          <h4>
            <strong>6.THIRD-PARTY WEBSITES</strong>
          </h4>
          <p>
            The Application may contain links to third-party websites and applications of interest, including
            advertisements and external services, that are not affiliated with us. Once you have used these links to
            leave the Application, any information you provide to these third parties is not covered by this Privacy
            Policy, and we cannot guarantee the safety and privacy of your information. Before visiting and providing
            any information to any third-party websites, you should inform yourself of the privacy policies and
            practices (if any) of the third party responsible for that website, and should take those steps necessary
            to, in your discretion, protect the privacy of your information. We are not responsible for the content or
            privacy and security practices and policies of any third parties, including other sites, services or
            applications that may be linked to or from the Application.
          </p>
        </div>

        <div id="seventh">
          <h4>
            <strong>7.HOW WE COMMITTED TO PROVIDE SECURITY? </strong>
          </h4>
          <p>
            We use administrative, technical, and physical security measures to help protect your personal information.
            While we have taken reasonable steps to secure the personal information you provide to us, please be aware
            that despite our efforts, no security measures are perfect or impenetrable, and no method of data
            transmission can be guaranteed against any interception or other type of misuse. Any information disclosed
            online is vulnerable to interception and misuse by unauthorized parties. Therefore, we cannot guarantee
            complete security if you provide personal information.
          </p>
          <p>
            if your account closed we may keep your personal data and other information required by law according to our
            data retention policy.
          </p>
        </div>
        <div id="eighth">
          <h4>
            <strong>8.HOW CAN YOU CONTACT US ABOUT THIS NOTICE? </strong>
          </h4>
          <p>
            If you have questions or comments about this notice, you may email us at{" "}
            <a href="mailto:gwshngt1@memphis.edu">gwshngt1@memphis.edu</a>
            or by post to:
          </p>
          <p>
            University of Memphis  <br />
            McCord Hall Room 200 <br />
            School of Social Work   <br />
            Memphis, TN 38152
            <br />
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
